import { ProviderConfig } from 'launchdarkly-react-client-sdk'
import { cookieInterfaces } from 'utils/cookies'

const defaultTestLaunchDarklyClientId = '61c0ab9d9911d40d25ac6d92'
const defaultUrls = {
  base: 'https://clientsdk.launchdarkly.us',
  events: 'https://events.launchdarkly.us',
  stream: 'https://clientstream.launchdarkly.us'
}

export const launchDarklyConfig: ProviderConfig = {
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID ?? defaultTestLaunchDarklyClientId,
  options: {
    streaming: false,
    baseUrl: process.env.REACT_APP_LAUNCH_DARKLY_BASE_URL ?? defaultUrls.base,
    eventsUrl: process.env.REACT_APP_LAUNCH_DARKLY_EVENTS_URL ?? defaultUrls.events,
    streamUrl: process.env.REACT_APP_LAUNCH_DARKLY_STREAM_URL ?? defaultUrls.stream,
    fetchGoals: false,
    sendLDHeaders: false
  },
  context: {
    kind: 'user',
    key: 'default-user',
    custom: {
      useTestFlags: cookieInterfaces.maxLDTest.get() === 'true'
    }
  }
}
